import { OFFLINE_USER_ELITE_OFFER_REPORTS_FETCHED_SUCCESS } from '../constants/actionTypes';

const initialState = {
  offline_user_elite_offers: [],
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
  role: {
    message: '',
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case OFFLINE_USER_ELITE_OFFER_REPORTS_FETCHED_SUCCESS:
      return {
        ...state,
        OfflineUserEliteOffer: action.payload.OfflineUserEliteOffer,
        pager: action.payload.pager,
      };

    default:
      return state;
  }
};
